import apiService from '../apiService'

const apiPath = '/pdf'

export const pdfController = (configService) => {
	const service = apiService(configService)
	return {
		uploadFiletoSpaceTax: (params) => {
			return service.post({
				url: `${apiPath}/uploadFiletoSpaceTax`,
				body: { ...params, type_insure: 'ตรอ' },
			})
		},
		uploadFiletoSpace: (params) => {
			return service.post({
				url: `${apiPath}/uploadFiletoSpace`,
				body: { ...params, type_insure: 'ตรอ' },
			})
		},
		uploadFiletoSpaceAgain: (params) => {
			return service.post({
				url: `${apiPath}/uploadFiletoSpaceAgain`,
				body: { ...params },
			})
		},
		uploadTaxInvoiceInsure: (params) => {
			return service.post({
				url: `${apiPath}/uploadTaxInvoiceInsure`,
				body: { ...params },
			})
		},
	}
}
